export default __webpack_public_path__ + "static/media/icon-bootstrap.2dfc8afa.svg";